export default __webpack_public_path__ + "static/media/vLink.ca599023.svg";